import { SegmentedValue } from 'antd/es/segmented';
import { atom } from 'jotai';
import { IWebhook } from './types';

const activeFilterAtom = atom<SegmentedValue>('total');
const selectedWebhookAtoms = atom<string[]>([]);
const currentWebhookRowAtom = atom<IWebhook>({} as IWebhook);
const showHistoryAtom = atom(false);

const webhooksSettingsAtom = atom((get) => {
  return {
    activeFilter: get(activeFilterAtom),
    selectedWebhooks: get(selectedWebhookAtoms),
  };
});

export {
  activeFilterAtom,
  selectedWebhookAtoms,
  webhooksSettingsAtom,
  showHistoryAtom,
  currentWebhookRowAtom,
};
